// Dhobara: small helper for pushing custom conversion events to Google Tag
// Manager's dataLayer (see src/util/includeScripts.js for how gtm.js is
// loaded, and the Dhobara media plan / project docs for the tracking plan).
//
// GTM tags (Meta Pixel, TikTok Pixel, Google Ads conversions, GA4 events)
// are configured inside the GTM container with triggers that match on the
// `event` name pushed here - so adding a new tag in GTM for one of these
// events requires no further code changes.

/**
 * Push a custom event to GTM's dataLayer.
 *
 * No-ops on the server (SSR) and safely no-ops if GTM isn't configured
 * (REACT_APP_GTM_ID unset) - `window.dataLayer` just accumulates an array
 * that nothing reads in that case, so this is always safe to call.
 *
 * @param {string} event - event name, matched by a GTM trigger
 * @param {Object} [data] - additional event parameters (e.g. value, currency)
 */
export const pushToDataLayer = (event, data = {}) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};
